import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { Model } from '../../../../models/brand.interface';
import { Environment } from '../../../../models/environment.type';

import * as filterHelpers from 'src/app/modules/marketing/components/compatibility/helpers/brand-filter.helpers';
import { MachineType } from '../../../../models/machine-type.interface';
import { CompatibilityService } from '../../../../services/compatibility.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgFor } from '@angular/common';

@Component({
    selector: 'app-machines-filter-panel',
    templateUrl: './machines-filter-panel.component.html',
    styleUrls: ['./machines-filter-panel.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        NgFor,
        TranslateModule,
    ],
})
export class MachinesFilterPanelComponent implements OnChanges {
  @Input() allModels: Model[] = [];
  @Output() filterModels = new EventEmitter<Model[]>();

  environmentFilter: Environment | 'embedded' = 'all';
  equipmentFilters: (MachineType | 'all')[] = ['all'];
  machineTypes: MachineType[] = this.compatibilityService.machineTypes;

  constructor(private compatibilityService: CompatibilityService) {}

  ngOnChanges(): void {
    setTimeout(() => {
      this.applyFilters();
    });
  }

  applyFilters(): void {
    let models = [...this.allModels];
    models = filterHelpers.filterModelsByEnvironment(
      models,
      this.environmentFilter
    );
    models = filterHelpers.filterModelsByEquipment(
      models,
      this.equipmentFilters
    );

    this.filterModels.emit(models);
  }

  onEnvironmentClick(filter: Environment | 'embedded'): void {
    if (this.environmentFilter === filter && filter !== 'all') {
      this.environmentFilter = 'all';
    } else {
      this.environmentFilter = filter;
    }

    this.applyFilters();
  }

  onEquipmentClick(filter: MachineType | 'all'): void {
    if (filter === 'all') {
      this.equipmentFilters = ['all'];
    } else {
      this.equipmentFilters = this.equipmentFilters.filter((f) => {
        return f !== 'all';
      });
      if (this.equipmentFilters.includes(filter)) {
        this.equipmentFilters = this.equipmentFilters.filter((f) => {
          return f !== filter;
        });
      } else {
        this.equipmentFilters.push(filter);
      }
    }

    if (this.equipmentFilters.length === 0) {
      this.equipmentFilters = ['all'];
    }

    this.applyFilters();
  }
}
